import { apiClient } from "../apiClient";
export const DON_VI_HANH_CHINH_ENDPOINT = "don-vi-hanh-chinh";
export const donViHanhChinhApi = {
  SelectAll: () => apiClient.get(`${DON_VI_HANH_CHINH_ENDPOINT}`),
};
